import React from 'react'

const HTMLRendered = ({ data = '' }) => {
  return <div dangerouslySetInnerHTML={{ __html: data }} />
}

export default HTMLRendered
